import icons from "../../../Assets/Icons/icons";
import {
  EnumSurveyAnswerStatus,
  DateFormatTypeEnum,
  DateTypeEnum,
  RangeTypeEnum,
} from "../../../Common/Enums/EnumsTypes";
import { DateComponentProps } from "../DateAndTimeTypeProps";
import "../SCSS/styles.css";
import { addDays, addYears } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DateAndTime({
  surveyAnswersInfo,
  questionId,
  surveyAnswers,
  isPreview,
  handleChangeDate,
  handleChangeFromAndTo,
}: DateComponentProps) {
  const dateInfo =
    surveyAnswersInfo.surveyInfo.questionsInfo.questionObj[questionId].dateInfo;
  const minDate = () => {
    const today = new Date().toISOString().split("T")[0];
    return today;
  };
  function selectedDateValue(
    dateType: string,
    dateFormat: string | undefined,
    rangeType?: string
  ) {
    if (dateType === DateTypeEnum.DATE) {
      switch (dateFormat) {
        case DateFormatTypeEnum.DATE:
        case DateFormatTypeEnum.MONTH:
          return surveyAnswers?.[questionId]?.val
            ? new Date(surveyAnswers?.[questionId]?.val?.from ?? null)
            : null;
        case DateFormatTypeEnum.YEAR:
          return surveyAnswers?.[questionId]?.val
            ? new Date(surveyAnswers?.[questionId]?.val?.year ?? null)
            : null;
        default:
          return null;
      }
    } else {
      if (rangeType === RangeTypeEnum.FROM) {
        switch (dateFormat) {
          case DateFormatTypeEnum.DATE:
          case DateFormatTypeEnum.MONTH:
          case DateFormatTypeEnum.YEAR:
            return surveyAnswers?.[questionId]?.val?.from
              ? new Date(surveyAnswers?.[questionId]?.val?.from ?? null)
              : null;
          default:
            return null;
        }
      } else {
        switch (dateFormat) {
          case DateFormatTypeEnum.DATE:
          case DateFormatTypeEnum.MONTH:
          case DateFormatTypeEnum.YEAR:
            return surveyAnswers?.[questionId]?.val?.to
              ? new Date(surveyAnswers?.[questionId]?.val?.to ?? null)
              : null;
          default:
            return null;
        }
      }
    }
  }
  //date formater
  function dateFormatter(dateFormat: string | undefined) {
    switch (dateFormat) {
      case DateFormatTypeEnum.DATE:
        return "dd/MM/yyyy";
      case DateFormatTypeEnum.MONTH:
        return "MM/dd/yyyy";
      case DateFormatTypeEnum.YEAR:
        return "yyyy";
      default:
        return dateFormat;
    }
  }
  //label
  function dynamicLabelName(dateFormat: string) {
    switch (dateFormat) {
      case DateFormatTypeEnum.DATE:
        return "Date";
      case DateFormatTypeEnum.MONTH:
        return "Date";
      case DateFormatTypeEnum.YEAR:
        return "Year";
      default:
        return "";
    }
  }
  return (
    <div className="supplier-view-date-cover">
      <div className="date-view-mode-option-cover">
        {dateInfo?.dateType === DateTypeEnum.DATE && (
          <div>
            <div className="date-text">
              {dynamicLabelName(dateInfo?.dateFormat)}
            </div>
            <div className="date-picker-cover">
              <div className="date-picker">
                <DatePicker
                  className="date-input"
                  onKeyDown={(e) => e.preventDefault()}
                  dateFormat={dateFormatter(dateInfo?.dateFormat)}
                  onChange={(date) =>
                    surveyAnswersInfo?.surveyStatus !==
                      EnumSurveyAnswerStatus?.COMPLETED &&
                    !surveyAnswers?.[questionId!]?.notApplicableInfo
                      ?.isNotApplicable &&
                    handleChangeDate(date)
                  }
                  selected={
                    selectedDateValue(
                      surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[
                        questionId
                      ]?.dateInfo?.dateType!,
                      surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[
                        questionId
                      ]?.dateInfo?.dateFormat
                    ) ?? null
                  }
                  showYearPicker={
                    dateInfo?.dateFormat === DateFormatTypeEnum.YEAR
                  }
                  disabled={
                    isPreview ||
                    surveyAnswersInfo?.surveyStatus ===
                      EnumSurveyAnswerStatus?.COMPLETED ||
                    surveyAnswers?.[questionId!]?.notApplicableInfo
                      ?.isNotApplicable
                  }
                />
              </div>

              <span className="calendar-icon">{icons.calendarIcon}</span>
            </div>
          </div>
        )}
        {dateInfo?.dateType === DateTypeEnum.RANGE && (
          <div className="date-from-to-cover">
            <div className="date-from-cover">
              <div className="date-text-from">From</div>
              <div className="date-picker-cover-from">
                <div className="date-picker">
                  <DatePicker
                    onKeyDown={(e) => e.preventDefault()}
                    className="date-input-from"
                    dateFormat={dateFormatter(dateInfo?.dateFormat)}
                    onChange={(date) =>
                      surveyAnswersInfo?.surveyStatus !==
                        EnumSurveyAnswerStatus?.COMPLETED &&
                      !surveyAnswers?.[questionId!]?.notApplicableInfo
                        ?.isNotApplicable &&
                      handleChangeFromAndTo(date, RangeTypeEnum.FROM)
                    }
                    selected={
                      selectedDateValue(
                        surveyAnswersInfo.surveyInfo.questionsInfo
                          .questionObj?.[questionId]?.dateInfo?.dateType!,
                        surveyAnswersInfo.surveyInfo.questionsInfo
                          .questionObj?.[questionId]?.dateInfo?.dateFormat,
                        RangeTypeEnum.FROM
                      ) ?? null
                    }
                    showYearPicker={
                      dateInfo?.dateFormat === DateFormatTypeEnum.YEAR
                    }
                    disabled={
                      isPreview ||
                      surveyAnswersInfo?.surveyStatus ===
                        EnumSurveyAnswerStatus?.COMPLETED ||
                      surveyAnswers?.[questionId!]?.notApplicableInfo
                        ?.isNotApplicable
                    }
                  />
                </div>
                <span className="calendar-icon-from">{icons.calendarIcon}</span>
              </div>
            </div>
            <div className="date-to-cover">
              <div className="date-text-to">To</div>
              <div className="date-picker-cover-to">
                <div className="date-picker">
                  <DatePicker
                    className="date-input-to"
                    onKeyDown={(e) => e.preventDefault()}
                    dateFormat={dateFormatter(dateInfo?.dateFormat)}
                    onChange={(date) =>
                      surveyAnswersInfo?.surveyStatus !==
                        EnumSurveyAnswerStatus?.COMPLETED &&
                      !surveyAnswers?.[questionId!]?.notApplicableInfo
                        ?.isNotApplicable &&
                      handleChangeFromAndTo(date, RangeTypeEnum.TO)
                    }
                    selected={
                      selectedDateValue(
                        surveyAnswersInfo.surveyInfo.questionsInfo
                          .questionObj?.[questionId]?.dateInfo?.dateType!,
                        surveyAnswersInfo.surveyInfo.questionsInfo
                          .questionObj?.[questionId]?.dateInfo?.dateFormat,
                        RangeTypeEnum.TO
                      ) ?? null
                    }
                    showYearPicker={
                      dateInfo?.dateFormat === DateFormatTypeEnum.YEAR
                    }
                    disabled={
                      !surveyAnswers?.[questionId]?.val?.from ||
                      surveyAnswersInfo?.surveyStatus ===
                        EnumSurveyAnswerStatus?.COMPLETED ||
                      surveyAnswers?.[questionId!]?.notApplicableInfo
                        ?.isNotApplicable
                    }
                    minDate={
                      dateInfo?.dateFormat === DateFormatTypeEnum.YEAR
                        ? addYears(
                            new Date(surveyAnswers?.[questionId]?.val?.from),
                            1
                          )
                        : addDays(
                            new Date(surveyAnswers?.[questionId]?.val?.from),
                            1
                          )
                    }
                  />
                </div>
                <span className="calendar-icon-to">{icons.calendarIcon}</span>
              </div>
              {surveyAnswers?.[questionId]?.val?.from &&
                !surveyAnswers?.[questionId]?.val?.to && (
                  <div className="to-date-validation">
                    Please fill the empty field
                  </div>
                )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DateAndTime;
